import decorateWithDefaultProps from './decorate-with-default-props';

export default decorateWithDefaultProps;
export { decorateWithDefaultProps };
